import React, {useContext, useEffect} from 'react'
import './../css/header.css'
import {
    Link,
    useLocation
  } from "react-router-dom";
import $ from 'jquery'
import DataContext from "./../data/DataContext";

function Header() {
    const location = useLocation();
    const dataConf = useContext(DataContext)
    
    useEffect(()=>{
        const localPath =  location.pathname.split('/');
        // console.log(localPath)
        if(localPath[1] == 'lotto') {
            MenuChk(document.getElementById("lotto-btn"))
        }else if(localPath[1] == 'lothun'){
            MenuChk(document.getElementById("lothun-btn"))
        }else  if(localPath[1] == 'notify'){
            MenuChk(document.getElementById("notify-btn"))
        }else  if(localPath[1] == 'setting'){
            MenuChk(document.getElementById("setting-btn"))
        }else  if(localPath[1] == 'password'){
            MenuChk(document.getElementById("password-btn"))
        }
    },[])

    const MenuChk = (e)=>{
        $('.menu-m').removeClass('btn-active')
        e.classList.toggle('btn-active')
    }
    const logout = ()=>{
        localStorage.clear();
        dataConf.loginAccess(null,null,null,null,null,null)
    }

    const btnCollapse = (e)=>{
        $('.navbar-collapse').toggleClass('show')
        if($('.navbar-toggler').attr('aria-expanded') === "false"){
            $('.navbar-toggler').attr('aria-expanded','true')
        }else{
            $('.navbar-toggler').attr('aria-expanded','false')
        }
    }
  return (
   <nav className="navbar navbar-expand-lg navbar-dark bg-danger topnav">
        <div className="container">
            <a className="navbar-brand" href="#">
                <img src={`/web/${process.env.REACT_APP_SITE}/logo.png`} alt="" height="40"/>
            </a>
            <button className="navbar-toggler" type="button" onClick={btnCollapse}  aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                    <Link className="btn btn-sm fw-bolder menu-m " id="lotto-btn" aria-current="page" to="/lotto/win" onClick={(e)=>MenuChk(e.target)}>หวย</Link>
                </li>
                <li className="nav-item">
                    <Link className="btn btn-sm fw-bolder menu-m" id="lothun-btn" aria-current="page" to="/lothun/win" onClick={(e)=>MenuChk(e.target)}>หวยหุ้น</Link>
                </li>
            </ul>
            <span className="navbar-text text-sm menu-s">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    {process.env.REACT_APP_ADMIN_TYPE == 'SA' && <> 
                        <li className="nav-item">
                            <Link className="nav-link btn-sm fw-bolder menu-m" id="notify-btn" aria-current="page" to="/notify" onClick={(e)=>MenuChk(e.target)}>แจ้งเตือน</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link btn-sm fw-bolder menu-m" id="notify-btn" aria-current="page" to="/news" onClick={(e)=>MenuChk(e.target)}>ข่าวสาร</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link btn-sm fw-bolder menu-m" id="setting-btn" aria-current="page" to="/setting" onClick={(e)=>MenuChk(e.target)}>ควบคุมระบบ</Link>
                        </li>
                    </> }
                    <li className="nav-item">
                        <Link className="nav-link btn-sm fw-bolder menu-m" id="password-btn" to="/password" onClick={(e)=>MenuChk(e.target)}>เปลี่ยนรหัสผ่าน</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link btn-sm fw-bolder " to="/login" onClick={logout}>ออกจากระบบ</Link>
                    </li>
                </ul>
            </span>
            </div>
        </div>
    </nav>

  )
}

export default Header